import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	ownerName: {
		id: 'search-page.relay.compass.owner-name',
		defaultMessage: 'Owned by {ownerName}',
		description: 'Indicates which team owns this component.',
	},
});
